import * as React from 'react';
import { IDoctorSellerSetting } from 'src/entity/DoctorEntity';
import { IAgentInfo } from 'src/entity/AgentEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { IMallPharmacyDetail, ISettingOnlineData, ISettingPharmacySource, IMallPharmacySettingData, IMallPharmacySettingInfo } from 'src/entity/MallEntity';
import Form, { WrappedFormUtils } from 'antd/lib/form/Form';
import LocationService from 'src/services/LocationService';
import { FormItemProps } from 'antd/lib/form';
import { Row, Col, Radio, Select, Button, Divider } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import I18N from 'src/services/I18NService';
import { EnumOrderType } from 'src/constants/Order';
import PharmacySelectBox from './PharmacySelectBox';
import * as uuid from 'uuid';
import { isArray } from 'util';
import { validateRegionError } from 'src/redux/actions/drugStoreCreator';
import { getLocationChain } from 'src/redux/actions/locationCreator';
import { localSettingInfo2Source } from 'src/redux/actions/mallPharmacyCreator';
import { EnumMedicineCategory } from 'src/constants/enum';

/**
 * 药库设置的数据
 *
 * @export
 * @interface IMallPharmacySettingData
 */
export interface IPharmacySettingData {
  // /** 设置的配药中心列表 */
  // dataDrugStoreList: ISettingOnlineData[];
  // /** 设置的单元药库列表， 需要根据配药中心或者代理商的seller_user过滤单元药库列表 */
  // dataPharmacyList: ISettingPharmacySource[];
  /** 是否在线订购 */
  isOrderOnline: boolean;
  /** 云药房-在线订购的数据（配药中心+药库+价格模式） */
  onlineDataList: ISettingOnlineData[];
  /** 云药房-未在线订购的数据（代理商的药库+价格模式） */
  offlineDataList: ISettingPharmacySource[];
  /** 本地药房转换后的数据 */
  localDataList: ISettingOnlineData[];
  /** 选中的默认药品单元药库 */
  defaultMedicinePharmacy: string | undefined;
  /** 选中的默认处方单元药库 */
  defaultPrescriptionPharmacy: string | undefined;
}

interface IPharmacySettingProps {
  /** 是否是代理商 */
  isAgent: boolean;
  /** 用户详情 */
  userInfo: IAgentInfo | IDrugStoreInfo | undefined;
  /** 代理商的配药中心 */
  drugStoreList: IDrugStoreInfo[];
  /** 代理商生效的单元药库 */
  pharmacyList: IMallPharmacyDetail[];
  /** 父级表单 */
  form: WrappedFormUtils;
  /** 是否是编辑状态 */
  isEdit: boolean;
  /** 是否显示继承药库按钮 */
  showExtend: boolean;
  /** 医生地址的ID */
  location?: number;
  // /** 是否在线订购 */
  // isOrderOnline: boolean;
  /** 药库设置的数据 */
  settingData: IPharmacySettingData;
  /** 本地药房下拉选项 */
  localSettingData: IMallPharmacySettingInfo[];
  /** 数据变更回调 */
  cbSettingData(data: IPharmacySettingData): void;
}

// interface IPharmacySettingState {
//   /** 在线订购的数据（配药中心+药库+价格模式） */
//   onlineDataList: ISettingOnlineData[];
//   /** 未在线订购的数据（代理商的药库+价格模式） */
//   offlineDataList: ISettingPharmacySource[];
//   /** 选中的默认药品单元药库 */
//   defaultMedicinePharmacy: string | undefined;
//   /** 选中的默认处方单元药库 */
//   defaultPrescriptionPharmacy: string | undefined;
// }

class PharmacySetting extends React.Component<IPharmacySettingProps, IPharmacySettingData> {
  constructor(props: IPharmacySettingProps) {
    super(props);

    this.state = {
      isOrderOnline: false,
      onlineDataList: [],
      offlineDataList: [],
      localDataList: [],
      defaultMedicinePharmacy: undefined,
      defaultPrescriptionPharmacy: undefined,
    };
  }

  async componentDidMount() {
    await LocationService.initArea();
  }

  async UNSAFE_componentWillReceiveProps(nextProps: IPharmacySettingProps) {
    const { settingData } = nextProps;
    this.setState({
      isOrderOnline: settingData.isOrderOnline,
      onlineDataList: settingData.onlineDataList,
      offlineDataList: settingData.offlineDataList,
      localDataList: settingData.localDataList,
      defaultMedicinePharmacy: settingData.defaultMedicinePharmacy,
      defaultPrescriptionPharmacy: settingData.defaultPrescriptionPharmacy,
    });
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 获取默认单元药库下拉选项
   *
   * @memberof PharmacySetting
   */
  getPharmacyOptionList = (orderType: EnumOrderType): JSX.Element[] => {
    // 所有选中的单元药库
    const tempPharmacyList: ISettingPharmacySource[] = [];
    if (this.state.isOrderOnline) {
      for (const drugStoreObj of this.state.onlineDataList) {
        for (const pharmacyObj of drugStoreObj.pharmacySourceList) {
          tempPharmacyList.push(pharmacyObj);
        }
      }
    } else {
      for (const pharmacyObj of this.state.offlineDataList) {
        tempPharmacyList.push(pharmacyObj);
      }
    }

    const options: JSX.Element[] = [];
    for (const option of tempPharmacyList) {
      if (!!option.source) {
        if (option.source.order_type === EnumOrderType.全部订单 || option.source.order_type === orderType) {
          options.push(
            <Select.Option key={option.source.uuid} value={option.source.uuid}>
              {option.source.name}
            </Select.Option>
          );
        }
      }
    }
    return options;
  };

  /**
   * 在线订购状态变更时触发
   *
   * @memberof PharmacySetting
   */
  onChangeOrderOnline = async (event: RadioChangeEvent) => {
    // 清空默认单元药库
    this.props.form.setFieldsValue({
      unit_pharmacy_default_medicine: undefined,
      unit_pharmacy_default_prescription: undefined,
    });

    this.props.cbSettingData({
      isOrderOnline: event.target.value,
      onlineDataList: [],
      offlineDataList: [],
      localDataList: localSettingInfo2Source(this.props.localSettingData),
      defaultMedicinePharmacy: undefined,
      defaultPrescriptionPharmacy: undefined,
    });
  };

  /**
   * 默认药品订单单元药库变更触发
   *
   * @memberof PharmacySetting
   */
  onChangeSelectedMedicinePharmacy = (defaultMedicinePharmacy: string | undefined) => {
    this.setState({
      defaultMedicinePharmacy,
    });

    const { isOrderOnline, onlineDataList, offlineDataList, localDataList, defaultPrescriptionPharmacy } = this.state;
    this.props.cbSettingData({
      isOrderOnline,
      onlineDataList,
      offlineDataList,
      localDataList,
      defaultMedicinePharmacy,
      defaultPrescriptionPharmacy,
    });
  };

  /**
   * 云药房-默认处方订单单元药库变更触发
   *
   * @memberof PharmacySetting
   */
  onChangeSelectedPrescriptionPharmacy = (defaultPrescriptionPharmacy: string | undefined) => {
    this.setState({
      defaultPrescriptionPharmacy,
    });

    const { isOrderOnline, onlineDataList, offlineDataList, localDataList, defaultMedicinePharmacy } = this.state;
    this.props.cbSettingData({
      isOrderOnline,
      onlineDataList,
      offlineDataList,
      localDataList,
      defaultMedicinePharmacy,
      defaultPrescriptionPharmacy,
    });
  };

  // #region 云药房
  /**
   * 新增药库设置时触发
   *
   * @memberof PharmacySetting
   */
  onAddCloudSettingData = () => {
    const { onlineDataList, isOrderOnline } = this.state;

    if (isOrderOnline) {
      let isAdd = false;
      if (onlineDataList.length > 0) {
        const lastData = onlineDataList[onlineDataList.length - 1];
        if (!!lastData.seller_user) {
          isAdd = true;
        }
      } else {
        isAdd = true;
      }

      if (isAdd) {
        const parentKey = uuid.v4();
        const childKey = uuid.v4();
        onlineDataList.push({
          uniqueKey: parentKey,
          pharmacySourceList: [
            {
              uniqueKey: childKey,
              medicine_group: undefined,
              medicine_price_policy: undefined,
              source: undefined,
            },
          ],
        });

        this.setState({
          onlineDataList,
        });
      }
    } else {
      const { offlineDataList } = this.state;
      offlineDataList.push({
        uniqueKey: uuid.v4(),
        medicine_group: undefined,
        medicine_price_policy: undefined,
        source: undefined,
      });
      this.setState({
        offlineDataList,
      });
    }
  };

  /**
   * @description 云药房-新增设置数据触发
   * @memberof PharmacySetting
   */
  cloudSettingDataAdd = (key: string) => {
    const { isOrderOnline, onlineDataList, offlineDataList } = this.state;
    if (isOrderOnline) {
      const tempData = onlineDataList.find((t) => t.uniqueKey === key);
      if (!!tempData) {
        const uniqueKey = uuid.v4();
        tempData.pharmacySourceList.push({
          uniqueKey,
          medicine_group: undefined,
          medicine_price_policy: undefined,
          source: undefined,
        });
        this.setState({
          onlineDataList,
        });

        // this.props.form.setFields({
        //   [`${tempData.uniqueKey}`]: { errors: [new Error('单元药库必填')] },
        // });
      }
    } else {
      offlineDataList.push({
        uniqueKey: uuid.v4(),
        medicine_group: undefined,
        medicine_price_policy: undefined,
        source: undefined,
      });

      this.setState({
        offlineDataList,
      });
    }
  };

  /**
   * 云药房-配药中心设置数据变更触发
   *
   * @param {number} index
   * @param {(ISettingDrugStore | undefined)} drugStore
   * @param {IMallPharmacySettingData[]} pharmacyList
   * @memberof PharmacySetting
   */
  cloudSettingDataChange = (key: string, drugStore: IDoctorSellerSetting, pharmacyList: ISettingPharmacySource[]): void => {
    const { isOrderOnline, onlineDataList, localDataList, defaultMedicinePharmacy, defaultPrescriptionPharmacy } = this.state;

    const tempMedicinePharmacy = pharmacyList.findIndex((t) => t.medicine_group === defaultMedicinePharmacy) > -1 ? defaultMedicinePharmacy : undefined;
    const tempPrescriptionPharmacy =
      pharmacyList.findIndex((t) => t.medicine_group === defaultPrescriptionPharmacy) > -1 ? defaultPrescriptionPharmacy : undefined;

    // 清空默认单元药库
    this.props.form.setFieldsValue({
      unit_pharmacy_default_medicine: tempMedicinePharmacy,
      unit_pharmacy_default_prescription: tempPrescriptionPharmacy,
    });

    if (!!isOrderOnline) {
      // 开通在线订购
      const tempData = onlineDataList.find((t) => t.uniqueKey === key);
      if (!!tempData) {
        tempData.name = drugStore.name;
        tempData.seller_user = drugStore.seller_user;
        tempData.pharmacySourceList = pharmacyList;
      }

      this.setState({
        onlineDataList,
        defaultMedicinePharmacy: tempMedicinePharmacy,
        defaultPrescriptionPharmacy: tempPrescriptionPharmacy,
      });
    } else {
      // 未开通在线订购
      this.setState({
        offlineDataList: pharmacyList,
        defaultMedicinePharmacy: tempMedicinePharmacy,
        defaultPrescriptionPharmacy: tempPrescriptionPharmacy,
      });
    }

    this.props.cbSettingData({
      isOrderOnline,
      onlineDataList,
      offlineDataList: pharmacyList,
      localDataList,
      defaultMedicinePharmacy: tempMedicinePharmacy,
      defaultPrescriptionPharmacy: tempPrescriptionPharmacy,
    });
  };

  /**
   * 云药房-删除设置数据触发
   *
   * @memberof PharmacySetting
   */
  cloudSettingDataDelete = (key: string) => {
    const { isOrderOnline, onlineDataList, offlineDataList, localDataList, defaultMedicinePharmacy, defaultPrescriptionPharmacy } = this.state;
    const tempOnlineData = onlineDataList.filter((t) => t.uniqueKey !== key);

    if (isOrderOnline) {
      this.setState({
        // 过滤选中的配药中心及单元药库数据
        onlineDataList: tempOnlineData,
      });
    } else {
      this.setState({
        // 过滤选中的单元药库数据
        offlineDataList: [],
      });
    }

    this.props.cbSettingData({
      isOrderOnline,
      onlineDataList: tempOnlineData,
      offlineDataList: [],
      localDataList,
      defaultMedicinePharmacy,
      defaultPrescriptionPharmacy,
    });
  };

  /**
   * 云药房-订购设置组件
   *
   * @memberof PharmacySetting
   */
  getCloudSettingItem = (): JSX.Element[] | JSX.Element => {
    // 获取医生职业地址省市区地区链
    const locationChain: number[] = getLocationChain(this.props.location);
    const { drugStoreList, isAgent, isEdit, showExtend, pharmacyList, userInfo, localSettingData } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { isOrderOnline, onlineDataList, offlineDataList } = this.state;
    if (!!userInfo) {
      if (isOrderOnline) {
        return onlineDataList.map((sellerData, index) => (
          <Form.Item required={false} key={sellerData.uniqueKey} style={{ marginBottom: '12px', border: '1px solid #dddddd', backgroundColor: '#f9f9f9' }}>
            {getFieldDecorator(sellerData.uniqueKey)(
              <PharmacySelectBox
                uniqueKey={sellerData.uniqueKey}
                isAgent={isAgent}
                isEdit={isEdit}
                showExtend={showExtend}
                userInfo={userInfo}
                isCloud={true}
                isOrderOnline={isOrderOnline}
                sellerList={drugStoreList.filter(
                  (d) =>
                    onlineDataList
                      .filter((t) => t.seller_user !== sellerData.seller_user)
                      .map((t) => t.seller_user)
                      .indexOf(d.seller_user) < 0
                )}
                pharmacyList={pharmacyList}
                drugStoreList={drugStoreList}
                localSettingData={localSettingData}
                locationChain={locationChain}
                dataSellerSetting={{
                  seller_user: sellerData.seller_user,
                  name: sellerData.name,
                }}
                dataPharmacyList={sellerData.pharmacySourceList}
                cbDataAdd={this.cloudSettingDataAdd}
                cbDataChange={this.cloudSettingDataChange}
                cbDataDelete={this.cloudSettingDataDelete}
              />
            )}
          </Form.Item>
        ));
      } else {
        const sellerList: IAgentInfo[] = [];
        if (!!isAgent && !!userInfo) {
          sellerList.push(userInfo as IAgentInfo);
        }

        if (offlineDataList.length > 0) {
          return (
            <Form.Item required={false} key={userInfo.seller_user} style={{ marginBottom: '12px', border: '1px solid #dddddd', backgroundColor: '#f9f9f9' }}>
              {getFieldDecorator(userInfo.seller_user)(
                <PharmacySelectBox
                  uniqueKey={userInfo.seller_user}
                  isAgent={isAgent}
                  isEdit={isEdit}
                  showExtend={showExtend}
                  userInfo={userInfo}
                  isCloud={true}
                  isOrderOnline={isOrderOnline}
                  sellerList={sellerList}
                  pharmacyList={pharmacyList}
                  drugStoreList={drugStoreList}
                  localSettingData={localSettingData}
                  locationChain={locationChain}
                  dataSellerSetting={{
                    seller_user: userInfo.seller_user,
                    name: userInfo.name,
                  }}
                  dataPharmacyList={offlineDataList}
                  cbDataAdd={this.cloudSettingDataAdd}
                  cbDataChange={this.cloudSettingDataChange}
                  cbDataDelete={this.cloudSettingDataDelete}
                />
              )}
            </Form.Item>
          );
        }
      }
    }

    return [];
  };

  // #endregion

  // #region 本地药房

  onAddLocalSettingData = () => {
    const { localDataList, isOrderOnline } = this.state;
    const { userInfo } = this.props;
    let isAdd = false;
    if (localDataList.length > 0) {
      const lastData = localDataList[localDataList.length - 1];
      if (!!lastData.seller_user) {
        isAdd = true;
      }
    } else {
      isAdd = true;
    }
    if (isAdd) {
      const parentKey = uuid.v4();
      const childKey = uuid.v4();
      const sellerUser = isOrderOnline ? undefined : !!userInfo ? userInfo.seller_user : undefined;
      localDataList.push({
        uniqueKey: parentKey,
        seller_user: sellerUser,
        pharmacySourceList: [
          {
            uniqueKey: childKey,
            medicine_group: undefined,
            medicine_price_policy: undefined,
            source: undefined,
          },
        ],
      });

      this.setState({
        localDataList,
      });
    }
  };

  /**
   * @description 本地药房-新增设置数据触发
   * @memberof PharmacySetting
   */
  localSettingDataAdd = (key: string) => {
    const { localDataList } = this.state;
    const tempData = localDataList.find((t) => t.uniqueKey === key);
    if (!!tempData) {
      const uniqueKey = uuid.v4();
      tempData.pharmacySourceList.push({
        uniqueKey,
        medicine_group: undefined,
        medicine_price_policy: undefined,
        source: undefined,
      });
      this.setState({
        localDataList,
      });
      // this.props.form.setFields({
      //   [`${tempData.uniqueKey}`]: { errors: [new Error('单元药库必填')] },
      // });
    }
  };

  /**
   * 本地药房-配药中心设置数据变更触发
   *
   * @param {number} index
   * @param {(ISettingDrugStore | undefined)} sellerData
   * @param {IMallPharmacySettingData[]} pharmacyList
   * @memberof PharmacySetting
   */
  localSettingDataChange = (key: string, sellerData: IDoctorSellerSetting, pharmacyList: ISettingPharmacySource[]): void => {
    const { isOrderOnline, onlineDataList, offlineDataList, localDataList, defaultMedicinePharmacy, defaultPrescriptionPharmacy } = this.state;

    // 开通在线订购
    const tempData = localDataList.find((t) => t.uniqueKey === key);
    if (!!tempData) {
      tempData.name = sellerData.name;
      tempData.seller_user = sellerData.seller_user;
      tempData.pharmacySourceList = pharmacyList;
    }
    this.setState({
      localDataList,
    });

    this.props.cbSettingData({
      isOrderOnline,
      onlineDataList,
      offlineDataList,
      localDataList,
      defaultMedicinePharmacy,
      defaultPrescriptionPharmacy,
    });
  };

  /**
   * 本地药房-删除设置数据触发
   *
   * @memberof PharmacySetting
   */
  localSettingDataDelete = (key: string) => {
    const { isOrderOnline, onlineDataList, offlineDataList, localDataList, defaultMedicinePharmacy, defaultPrescriptionPharmacy } = this.state;
    const tempLocalData = localDataList.filter((t) => t.uniqueKey !== key);
    this.setState({
      localDataList: tempLocalData,
    });
    this.props.cbSettingData({
      isOrderOnline,
      onlineDataList,
      offlineDataList,
      localDataList: tempLocalData,
      defaultMedicinePharmacy,
      defaultPrescriptionPharmacy,
    });
  };

  /**
   * @description 本地药房-订购设置
   * @memberof PharmacySetting
   */
  getLocalSettingItem = (): JSX.Element[] => {
    // 获取医生职业地址省市区地区链
    const locationChain: number[] = getLocationChain(this.props.location);
    const { drugStoreList, isAgent, isEdit, showExtend, pharmacyList, userInfo, localSettingData } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { isOrderOnline, localDataList } = this.state;

    let sellerList: Array<IAgentInfo | IDrugStoreInfo> = [];

    if (isOrderOnline) {
      sellerList = drugStoreList.concat([]);
    } else {
      if (!!isAgent && !!userInfo) {
        sellerList = [userInfo].concat([]);
        // sellerList.push(userInfo as IAgentInfo);
      }
    }

    if (!!userInfo) {
      return localDataList.map((sellerData, index) => (
        <Form.Item
          required={!isOrderOnline}
          key={sellerData.uniqueKey}
          style={{ marginBottom: '12px', border: '1px solid #dddddd', backgroundColor: '#f9f9f9' }}
        >
          {getFieldDecorator(sellerData.uniqueKey)(
            <PharmacySelectBox
              uniqueKey={sellerData.uniqueKey}
              isAgent={isAgent}
              isEdit={isEdit}
              showExtend={showExtend}
              userInfo={userInfo}
              isCloud={false}
              isOrderOnline={isOrderOnline}
              sellerList={sellerList.filter(
                (d) =>
                  localDataList
                    .filter((t) => t.seller_user !== sellerData.seller_user)
                    .map((t) => t.seller_user)
                    .indexOf(d.seller_user) < 0
              )}
              pharmacyList={pharmacyList}
              drugStoreList={drugStoreList}
              localSettingData={localSettingData}
              locationChain={locationChain}
              dataSellerSetting={{
                seller_user: sellerData.seller_user,
                name: sellerData.name,
              }}
              dataPharmacyList={sellerData.pharmacySourceList}
              cbDataAdd={this.localSettingDataAdd}
              cbDataChange={this.localSettingDataChange}
              cbDataDelete={this.localSettingDataDelete}
            />
          )}
        </Form.Item>
      ));
    }

    return [];
  };

  // #endregion

  render() {
    const { drugStoreList, isAgent, isEdit, userInfo } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { isOrderOnline, defaultMedicinePharmacy, defaultPrescriptionPharmacy, localDataList, offlineDataList } = this.state;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };

    return (
      <div key="PharmacySetting">
        {isAgent && (
          <Row gutter={24} style={{ margin: 0 }}>
            <Col span={24} style={{ padding: 0 }}>
              <Form.Item label={I18N.get('order_online')} {...formItemLayout} style={{ marginBottom: '12px' }}>
                {getFieldDecorator(`is_order_online`, {
                  initialValue: isOrderOnline,
                })(
                  <Radio.Group disabled={!isEdit || drugStoreList.length === 0} onChange={this.onChangeOrderOnline}>
                    <Radio value={true}>是</Radio>
                    <Radio value={false}>否</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
          </Row>
        )}
        {isAgent && isEdit && (
          <div style={{ marginBottom: '12px', fontSize: '14px' }}>
            <span style={{ color: '#555555' }}> {I18N.get('doc_tips_pharmacy_setting')}</span>
          </div>
        )}
        {/* 云药房-配药中心设置 */}
        <div style={{ marginBottom: '12px', fontSize: '16px' }}>
          {isEdit && isOrderOnline && <span className="colon-red">*</span>}
          <span style={{ color: '#00a2ff' }}>云药房</span>
        </div>
        {this.getCloudSettingItem()}
        {isEdit && (isOrderOnline || offlineDataList.length === 0) && (
          <Button type="primary" icon="plus" onClick={this.onAddCloudSettingData} style={{ marginBottom: '12px' }} />
        )}
        {/* {isEdit && isOrderOnline && <Button type="primary" icon="plus" onClick={this.onAddCloudSettingData} style={{ marginBottom: '12px' }} />} */}

        <Divider dashed={true} />

        {/* 本地药房 */}
        <div style={{ marginBottom: '12px', fontSize: '16px' }}>
          {isEdit && !isOrderOnline && <span className="colon-red">*</span>}
          <span style={{ color: '#00a2ff' }}>本地药房</span>
        </div>
        {isEdit && (
          <div style={{ marginBottom: '12px' }}>
            <span style={{ color: '#f31212' }}>重要提示：</span>
            <span style={{ color: '#555555' }}>您正在使用管理员权限越权管理医生的诊所药房。删除诊所药房的单元药库会造成医生</span>
            <span style={{ color: '#38ad6b' }}>本地库存</span>
            <span style={{ color: '#555555' }}>和</span>
            <span style={{ color: '#38ad6b' }}>零售价</span>
            <span style={{ color: '#555555' }}>的丢失；新增诊所药房的单元药库在医生本地没有库存量，新增诊所药房的单元药库的零售价会按照</span>
            &nbsp;
            <span style={{ color: '#09a8be' }}>供货价*(1+医生医事服务费比例)</span>
            &nbsp;
            <span style={{ color: '#555555' }}>计算；继承库存会更改用户的</span>
            <span style={{ color: '#38ad6b' }}>库存数据</span>
            <span style={{ color: '#555555' }}>。请和医生沟通后操作！</span>
          </div>
        )}

        {this.getLocalSettingItem()}
        {isEdit && !!userInfo && (isOrderOnline || localDataList.findIndex((t) => t.seller_user === userInfo.seller_user) < 0) && (
          <Button type="primary" icon="plus" onClick={this.onAddLocalSettingData} style={{ marginBottom: '12px' }} />
        )}

        {/* 默认单元药库 */}
        {isAgent && isOrderOnline && (
          <Row gutter={24} style={{ margin: '0 0 12px 0', backgroundColor: '#f5f5f5', padding: '16px 16px 16px 0' }}>
            <Col span={4} style={{ textAlign: 'right', color: '#222222', marginBottom: 6 }}>
              {I18N.get('unit_pharmacy_default')}
            </Col>
            <Col span={24} style={{ padding: 0 }}>
              <Form.Item label={I18N.get('nav_order_medicine')} style={{ marginBottom: 6 }} {...formItemLayout}>
                {getFieldDecorator(`unit_pharmacy_default_medicine`, {
                  rules: [{ required: false, message: `${I18N.get('common_choose')}${I18N.get('unit_pharmacy_default_medicine')}` }],
                  initialValue: defaultMedicinePharmacy,
                })(
                  <Select
                    disabled={!isEdit}
                    onChange={this.onChangeSelectedMedicinePharmacy}
                    placeholder={`${I18N.get('common_choose')}${I18N.get('unit_pharmacy_default_medicine')}`}
                    allowClear={true}
                  >
                    {this.getPharmacyOptionList(EnumOrderType.药品订单)}
                  </Select>
                )}
              </Form.Item>
            </Col>

            <Col span={24} style={{ padding: 0 }}>
              <Form.Item label={I18N.get('nav_order_prescription')} style={{ marginBottom: 0 }} {...formItemLayout}>
                {getFieldDecorator(`unit_pharmacy_default_prescription`, {
                  rules: [{ required: false, message: `${I18N.get('common_choose')}${I18N.get('unit_pharmacy_default_prescription')}` }],
                  initialValue: defaultPrescriptionPharmacy,
                })(
                  <Select
                    disabled={!isEdit}
                    onChange={this.onChangeSelectedPrescriptionPharmacy}
                    placeholder={`${I18N.get('common_choose')}${I18N.get('unit_pharmacy_default_prescription')}`}
                    allowClear={true}
                  >
                    {this.getPharmacyOptionList(EnumOrderType.处方订单)}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default PharmacySetting;

/**
 * 获取错误信息
 *
 * @export
 * @param {IPharmacySettingData} settingData
 * @returns {string}
 */
export function settingDataErrorMsg(settingData: IPharmacySettingData, drugStoreList: IDrugStoreInfo[], locationId: number | undefined): string {
  const errorMsgSet = new Set<string>();

  if (settingData.isOrderOnline) {
    if (settingData.onlineDataList.length === 0) {
      errorMsgSet.add('云药房配置不能为空');
    }
    for (const onlineObj of settingData.onlineDataList) {
      if (!onlineObj.seller_user) {
        errorMsgSet.add('云药房供应商不能为空');
      } else {
        const drugStoreObj = drugStoreList.find((drugStore) => drugStore.seller_user === onlineObj.seller_user);
        if (!!drugStoreObj && isArray(drugStoreObj.regions)) {
          const locationChain = getLocationChain(locationId);
          const regionError = validateRegionError(drugStoreObj.regions, locationChain);
          if (!!regionError) {
            errorMsgSet.add(`当前医生所在区域不在${onlineObj.name || ''}供应商服务区域范围`);
          }
        }
      }
      if (onlineObj.pharmacySourceList.length === 0) {
        errorMsgSet.add(`云药房供应商${onlineObj.name || ''}至少设置一个单元药库`);
      } else {
        for (const pharmacyObj of onlineObj.pharmacySourceList) {
          if (!pharmacyObj.medicine_group) {
            errorMsgSet.add(`云药房供应商${onlineObj.name || ''}单元药库不能为空`);
          }
        }
      }
    }
  }

  if (!settingData.isOrderOnline) {
    // if (settingData.offlineDataList.length === 0) {
    //   errorMsgSet.add('云药房供应商至少设置一个单元药库');
    // }
    for (const offlineObj of settingData.offlineDataList) {
      if (!offlineObj.medicine_group) {
        const tempName = !!offlineObj.source ? offlineObj.source.name : '';
        errorMsgSet.add(`云药房供应商${tempName || ''}单元药库不能为空`);
      }
    }

    if (settingData.localDataList.length === 0) {
      errorMsgSet.add('本地药房配置不能为空');
    }
  }
  for (const localObj of settingData.localDataList) {
    if (!localObj.seller_user) {
      errorMsgSet.add('本地药房供应商不能为空');
    } else {
      // const drugStoreObj = drugStoreList.find((drugStore) => drugStore.seller_user === localObj.seller_user);
      // if (!!drugStoreObj && isArray(drugStoreObj.regions)) {
      //   const locationChain = getLocationChain(locationId);
      //   const regionError = validateRegionError(drugStoreObj.regions, locationChain);
      //   if (!!regionError) {
      //     errorMsgSet.add(`当前医生所在区域不在${localObj.name || ''}供应商服务区域范围`);
      //   }
      // }
    }

    if (localObj.pharmacySourceList.length === 0) {
      errorMsgSet.add(`本地药房供应商${localObj.name || ''}至少设置一个单元药库`);
    } else {
      for (const pharmacyObj of localObj.pharmacySourceList) {
        if (!pharmacyObj.medicine_group) {
          errorMsgSet.add(`本地药房供应商${localObj.name || ''}单元药库不能为空`);
        }
      }
    }
  }
  return Array.from(errorMsgSet).join(', ');
}

/**
 * 数据处理
 *
 * @export
 * @param {IPharmacySettingData} settingData
 * @returns {{ drugStoreIdList: number[]; settingDataList: IMallPharmacySettingData[] }}
 */
export function pharmacySettingDataHandle(
  settingData: IPharmacySettingData,
  drugStoreList: IDrugStoreInfo[]
): { drugStoreUUIDList: string[]; cloudSettingData: IMallPharmacySettingData[]; localSettingData: IMallPharmacySettingData[] } {
  const drugStoreUUIDList: string[] = [];
  const cloudSettingData: IMallPharmacySettingData[] = [];
  const localSettingData: IMallPharmacySettingData[] = [];

  if (settingData.isOrderOnline) {
    for (const onlineObj of settingData.onlineDataList) {
      if (!!onlineObj.seller_user) {
        const drugStoreObj = drugStoreList.find((t) => t.seller_user === onlineObj.seller_user);
        if (!!drugStoreObj && !!drugStoreObj.uuid) {
          drugStoreUUIDList.push(drugStoreObj.uuid);
        }
      }

      for (const pharmacyObj of onlineObj.pharmacySourceList) {
        if (!!pharmacyObj.medicine_group) {
          cloudSettingData.push({
            medicine_group: pharmacyObj.medicine_group,
            medicine_price_policy: pharmacyObj.medicine_price_policy,
          });
        }
      }
    }
  } else {
    for (const pharmacyObj of settingData.offlineDataList) {
      if (!!pharmacyObj.medicine_group) {
        cloudSettingData.push({
          medicine_group: pharmacyObj.medicine_group,
          medicine_price_policy: pharmacyObj.medicine_price_policy,
        });
      }
    }
  }

  for (const localObj of settingData.localDataList) {
    for (const pharmacyObj of localObj.pharmacySourceList) {
      if (!!pharmacyObj.medicine_group) {
        localSettingData.push({
          medicine_group: pharmacyObj.medicine_group,
          medicine_price_policy: pharmacyObj.medicine_price_policy,
          stocking_inherit_from: pharmacyObj.stocking_inherit_from,
          type: pharmacyObj.source ? pharmacyObj.source.category || EnumMedicineCategory.中药 : EnumMedicineCategory.中药
        });
      }
    }
  }

  return {
    drugStoreUUIDList,
    cloudSettingData,
    localSettingData,
  };
}



// WEBPACK FOOTER //
// ./src/components/common/PharmacySetting.tsx